import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { EboObject } from '../base-classes/ebo-object';
import { Employee } from '../employee/employee';
import { PayType } from '../payroll/shared/pay-type.enum';
import { Route } from '../route/route';
import { DigitalLogType } from '../shared/digital-log-type.enum';
import { ReconcileType, ReconcileTypeMapping } from './reconcile-type.enum';

export class Reconcile extends EboObject {
  eventDate: Dayjs;
  employeeID: string;
  employee: Employee;
  logType: DigitalLogType;
  type: ReconcileType;
  routeID: string;
  route: Route;
  truckNum: string;
  origNum: number;
  destNum: number;
  payTypeID: PayType;
  milesCalc: number;
  milesPaid: number;
  comment: string;

  constructor(jsonData?: Partial<Reconcile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.eventDate) {
        this.eventDate = SDate.newUtc(jsonData.eventDate);
      }
      if (jsonData.employee) {
        this.employee = new Employee(jsonData.employee);
      }
      if (jsonData.route) {
        this.route = new Route(jsonData.route);
      }
    }
  }

  toShortString(): string {
    const response = `${ReconcileTypeMapping[this.type]}`;
    return response;
  }
}
